<div class="characteristics">
  <div class="form">
    <!-- PROPERTIES -->
    <div class="details-properties">
      <p class="details-title">{{ titleProperties }}</p>
      <ul class="details-select">
        <li class="details-checkbox" *ngFor="let item of listProperties; let i = index">
          <lib-input-checkbox [id]="item.id" [label]="item.label" (click)="selectItem(item)"></lib-input-checkbox>
        </li>
      </ul>
      <div class="details-more">
        <label for="more-details">Mais detalhes do imóvel</label>
        <app-multi-selection-tags id="more-details" [tags]="tags" [options]="options" value="value"></app-multi-selection-tags>
      </div>
    </div>
    <!-- CONDOMINIUM -->
    <div class="details-properties" [class.details-properties__condiminium]="true">
      <p class="details-title">{{ titleCondominium }}</p>
      <ul class="details-select" [class.details-select__condiminium]="true">
        <li class="details-checkbox" *ngFor="let item of listCondominium; let i = index">
          <lib-input-checkbox [id]="item.id" [label]="item.label" (click)="selectItem(item)"></lib-input-checkbox>
        </li>
      </ul>
      <div class="details-more">
        <label for="more-details">Detalhes do condomínio</label>
        <app-multi-selection-tags id="more-details" [tags]="tagsCondominiun" [options]="optionsCondominiun" value="value"></app-multi-selection-tags>
      </div>
    </div>
    <!-- DETAILS -->
    <div class="details-properties" [class.details-properties__details]="true">
      <p class="details-title">{{ titleCondominium }}</p>
      <div class="input-control">
        <app-input
          id="tags-properties"
          label="Tags relacionadas ao imóvel"
          maxlength="280"
          messageError="''"
          placeholder=""
          countNumber="280">
        </app-input>
      </div>
      <app-input
        id="details-internal"
        label="Descrição interna"
        maxlength="280"
        messageError="''"
        placeholder=""
        countNumber="280">
      </app-input>
    </div>

    <div class="btn-actions">
      <lib-button-tertiary>Cancelar</lib-button-tertiary>
      <lib-button-primary>Salvar</lib-button-primary>
    </div>
  </div>
</div>